import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../Button';
import Icon, { Icons } from '../Icon/Icon';
import ProgressLine from '../ProgressLine';
import './Confirmation.scss';

const sizeIconClose = 24;

const DEFAULT_ICONS_BY_TYPE = {
	default: 'CHECKMARK_CIRCLE_FILL',
	success: 'CHECKMARK_CIRCLE_FILL',
	warning: 'CHECKMARK_CIRCLE_FILL',
	error: 'XMARK_CIRCLE_FILL',
};

const Confirmation = ({
	id = null,
	type = 'default',
	className = '',
	icon,
	iconSize = 34,
	firstBtnText,
	onClickFirstBtn,
	iconLeftFirstBtn,
	iconRightFirstBtn,
	secondBtnText,
	onClickSecondBtn,
	iconLeftSecondBtn,
	iconRightSecondBtn,
	title = null,
	description = null,
	visibleClose = false,
	close = () => {},
	autoHideDuration,
}) => {
	return (
		<div className={classNames('Confirmation', className, type)}>
			<div className='Confirmation-header'>
				<div className='Confirmation-block-icon'>
					<ProgressLine timeAnimate={autoHideDuration / 1000} />

					<Icon
						className='Confirmation-header-icon'
						type={Icons[icon ? icon : DEFAULT_ICONS_BY_TYPE[type]]}
						width={iconSize}
						height={iconSize}
						onClick={() => {}}
					/>
				</div>

				<div className='Confirmation-block-title'>
					<div className='Confirmation-title'>{title}</div>
					<div className='Confirmation-text'>{description}</div>
				</div>

				{visibleClose && (
					<Icon
						className='Confirmation-close-icon'
						type={Icons.XMARK_CIRCLE_FILL}
						width={sizeIconClose}
						height={sizeIconClose}
						onClick={() => close(id)}
					/>
				)}
			</div>

			{(firstBtnText || secondBtnText) && (
				<div className='Confirmation-bottom'>
					{firstBtnText && (
						<Button
							styleType='secondary'
							iconBefore={iconLeftFirstBtn}
							iconAfter={iconRightFirstBtn}
							onClick={() => onClickFirstBtn()}
						>
							{firstBtnText}
						</Button>
					)}
					{secondBtnText && (
						<Button onClick={() => onClickSecondBtn()} iconBefore={iconLeftSecondBtn} iconAfter={iconRightSecondBtn}>
							{secondBtnText}
						</Button>
					)}
				</div>
			)}
		</div>
	);
};

Confirmation.propTypes = {
	id: PropTypes.string,
	type: PropTypes.oneOf(['default', 'success', 'warning', 'error']),
	className: PropTypes.string,
	icon: PropTypes.string,
	iconSize: PropTypes.number,
	firstBtnText: PropTypes.string,
	onClickFirstBtn: PropTypes.func,
	iconLeftFirstBtn: PropTypes.string,
	iconRightFirstBtn: PropTypes.string,
	secondBtnText: PropTypes.string,
	onClickSecondBtn: PropTypes.func,
	iconLeftSecondBtn: PropTypes.string,
	iconRightSecondBtn: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	description: PropTypes.string,
	visibleClose: PropTypes.bool,
	close: PropTypes.func,
	autoHideDuration: PropTypes.number,
};

export default Confirmation;
